import "rxjs"
import {ajax} from "rxjs/observable/dom/ajax"
import config from "../../config"
import errorHandlerBuilder from "../errorHandlerBuilder"
import {
  ACTION_COGOLAND_GET_SCHEDULE_BY_USER_ERROR,
  ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADED,
  ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADING,
  PATH_COGOLAND_SCHEDULE_BY_USER
} from "../../constants"

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_COGOLAND_GET_SCHEDULE_BY_USER_ERROR)

const epic = (action$, store)=>
  action$.ofType(ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      const {userId} = action.payload
      const params = {userId}

      return ajax({
        method: 'GET',
        url: `${api_server_host}${PATH_COGOLAND_SCHEDULE_BY_USER}?${$.param(params)}`,
        headers: {
          Authorization: `${type} ${token}`
        },
        responseType: 'json'
      }).map(data=> {
        
        return {
          type: ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADED,
          payload: data.response
        }
      }).catch(errorHandler)

    })

export default epic



// WEBPACK FOOTER //
// ./src/epics/cogoland/GetScheduleByUserEpic.js